import React, { Component } from 'react'
import { NavLink } from "react-router";
import EditIcon from '../Icons/Edit.svg'
import CertificateIcon from '../Icons/Certificate.svg'
import GoIcon from '../Icons/Go.svg'
import './List.css'

export default class ListEntry extends Component {
	constructor(props) {
		super(props)
		this.state = {}
	}
	render() {
		let Cert = []
		if (this.props.data.Certificate)
			Cert.push(<img className="Icon Green" src={CertificateIcon} title={
				"DNS Names: " + this.props.data.Certificate.DNSNames.join(', ') + "\n" +
				"Valid From: " + new Date(this.props.data.Certificate.ValidFrom*1000) + "\n" +
				"Valid To: " + new Date(this.props.data.Certificate.ValidTo*1000)
			} />)
		if (this.props.data.TestCertificate)
			Cert.push(<img className="Icon Yellow" src={CertificateIcon} title={
				"DNS Names: " + this.props.data.TestCertificate.DNSNames.join(', ') + "\n" +
				"Valid From: " + new Date(this.props.data.TestCertificate.ValidFrom*1000) + "\n" +
				"Valid To: " + new Date(this.props.data.TestCertificate.ValidTo*1000)
			} />)
		return (
			<redirect className="Row">
				<div className="Col Grow">
					<div className="Row">
						<div className="Hostname Grow">
							{this.props.data.Hostname}
							<NavLink to={"/ui/web/"+this.props.data.Hostname}><img className="Icon" src={EditIcon} /></NavLink>
						</div>
						<div class="Icons">{Cert}</div>
					</div>
					<div className="Col Grow">
						<div><a target="_blank" href={"https://"+this.props.data.Hostname}>https://{this.props.data.Hostname}</a> <img className="Icon" style={{height: '0.8em'}} src={GoIcon}/> http://{this.props.data.Target}:{this.props.data.Port443}</div>
						{this.props.data.Port8443?(
							<div><a target="_blank" href={"https://"+this.props.data.Hostname+":8443"}>https://{this.props.data.Hostname}:8443</a>  <img className="Icon" style={{height: '0.8em'}} src={GoIcon}/> http://{this.props.data.Target}:{this.props.data.Port8443}</div>
						):(<></>)}
					</div>
				</div>
			</redirect>
		)
	}
}